import React from "react";
import { doc } from "../MyPropertyDocuments/MyPropertyDocuments";
import { useTranslation } from "react-i18next";

interface DocListItemProps {
    isSelected: boolean;
    doc: doc;
    docSelect: (id: string, docName?: string) => void;
    idx: number
}

export default function DocListItem(props: DocListItemProps) {

    const { t } = useTranslation(["property", "rfr"]);

    const formatDate = (d: string) => {
        const options = { year: "numeric", month: "long", day: "numeric" } as const;
        const date = new Date(d)
        return date?.toLocaleDateString("en-CA", options)
    }

    return (
        <div className={"notice-container " + (props.isSelected ? "highlighted" : "")} onClick={() => {
            if (!props.isSelected || props.doc.FFE) {
                props.docSelect(props.doc.id || "")
            }
        }}>
            {props.idx === 0 &&
                <p className="report-date report notice-title report-title">
                    {formatDate(props.doc.maildate || props.doc.publisheddate || "")}
                </p>
            }
            <p className="report notice-title">
                {t(`rfr.notices.type.${props.doc.vendorproducttype}`, { ns: "rfr" }) as string}
            </p>
            <hr className="report-hr" />
        </div>
    )
}